export const getCurrentEdokYear = (state) => state.edok.year;
